<div class="card">
  <div *ngIf="headImage">
    <img class="card-img-top show-image" src="{{ headImage }}" />
  </div>
  <div class="card-body">
    <h3 class="news">{{ title }}</h3>
    <div *ngFor="let newsSectionCard of newsSectionCards">
      <div class="card-body">
        <h4 class="card-title">{{ newsSectionCard.title }}</h4>
        <p class="card-text">{{ newsSectionCard.shortBody }}</p>
        <p class="card-text">
          <i class="date">Date: {{ newsSectionCard.footText | dateFormat }}</i>
        </p>
        <p class="card-text">
          <a [href]="newsSectionCard.url">{{ newsSectionCard.buttonText }}</a>
        </p>
      </div>
      <br />
      <hr />
    </div>
    <p class="card-text">
      <a [href]="newsUrl">{{ seeAllNews }}</a>
    </p>
  </div>
</div>
